import React from 'react';
import { PublicContentPage } from './PublicContentPage';

export function PaymentProofsPage() {
  return <PublicContentPage type="proofs" title="পেমেন্ট প্রুফ" />;
}
